export enum ACCOUNT_FIRST_DAY {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
}
